/**
 * Costs Import Tab Component
 *
 * Placeholder for cost import functionality.
 * Will include:
 * - File upload for vendor cost sheets
 * - Connection-based sync status and triggers
 * - Import history and logs
 *
 * TODO: Implement import functionality when vendor import workflow is ready.
 */

import { Empty, Typography } from 'antd'
import { UploadOutlined } from '@ant-design/icons'

const { Text } = Typography

export function CostsImportTab() {
  return (
    <Empty
      image={<UploadOutlined style={{ fontSize: 64, color: '#bfbfbf' }} />}
      description={
        <div>
          <Text strong>Cost Import Coming Soon</Text>
          <br />
          <Text type="secondary">
            Import vendor cost sheets and sync data from connected platforms
          </Text>
        </div>
      }
      style={{ marginTop: 64 }}
    />
  )
}
